



import { defineAsyncComponent, defineComponent } from '@nuxtjs/composition-api';
import { gql } from 'graphql-tag';

import { contentableBlockColorFragment } from '@/composables/block-color';

export default defineComponent({
  components: {
    Page: defineAsyncComponent(() => import('@/pages/shows/router.vue')),
  },
  graphqlData: gql`
    fragment ScenkonstOtPerformanceListingData on ScenkonstOtPerformanceListingContent {
      title
      ...ContentableBlockColor
    }

    ${contentableBlockColorFragment}
  `,
});
